import React from 'react';
import SMUserResource from 'resources/SMUserResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';

class SMUUnapprovedReservationConfirmView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.formDidSubmit = this.formDidSubmit.bind(this);
  }

  componentDidMount() {
    $(this.refs.listContainer).find("input[type=radio]").on("change", (e)=>{
      $(".js-form-radio-select_message").hide();
      let $message = $(this.refs[e.currentTarget.id]);
      if ($message.length) {
        $message.fadeIn();
      }
    });
  }

  formDidSubmit(e) {
    e.preventDefault();
    let formData = new FormData(e.currentTarget);
    $(this.refs.listContainer).startLoading();
    SMUserResource.approveReservation(this.props.reservation, formData, (data, error, xhr)=> {
      $(this.refs.listContainer).stopLoading();

      if (!error) {
        if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidConfirm === 'function') {
          this.props.delegate.unapprovedReservationDidConfirm(data, xhr);
        }
      } else {
        if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToConfirm === 'function') {
          this.props.delegate.unapprovedReservationDidFailToConfirm(error, xhr);
        }
      }
    });
  }
  
  render() {
    {
      const reservation = this.props.reservation;
      return (
        <div ref="listContainer" className="form-casette maincol-lightbox__form">
          <h2 className="dashboard-title mb30 ta-c"
              dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000048")}} />
          <form onSubmit={this.formDidSubmit.bind(this)}>
            <div className="ta-c mb30">
              <SMFormSubmitButton
                title={I18n.t("dashboard.label_000211")}
                options={{className: "button-green maincol-buttonarea__button"}} />
            </div>
          </form>
        </div>
      );
    }

  }
}

export default SMUUnapprovedReservationConfirmView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUUnapprovedReservationConfirmView.jsx